var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "token-wrapper"
  }, [_vm.isDisclaimerRequired(_vm.$route.path) ? _c('disclaimer-modal', {
    on: {
      "disclaimer-accepted": _vm.onDisclaimerAccepted,
      "disclaimer-declined": _vm.onDisclaimerDeclined
    }
  }) : _vm._e(), _vm.showContent ? _c('div', {
    staticClass: "token"
  }, [_c('div', {
    staticClass: "token-data-wrapper"
  }, [_c('TokenPriceChartContainer', {
    key: _vm.symbol + _vm.selectedProvider + '-chart',
    attrs: {
      "symbol": _vm.symbol,
      "provider": _vm.selectedProvider,
      "currentPrice": _vm.currentPrice
    }
  }), _c('TokenPriceTableContainer', {
    key: _vm.symbol + _vm.selectedProvider + '-table',
    attrs: {
      "id": "token-price-table",
      "symbol": _vm.symbol,
      "provider": _vm.selectedProvider,
      "currentPrice": _vm.currentPrice
    }
  })], 1), _c('div', {
    staticClass: "space"
  })]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }